export const pharmacyConstant = {
    GET: 'PHARMACY_GET',
    GET_ALL_PHARMACY:'GET_ALL_PHARMACY',
    USER_LOADED:'USER_LOADED',
};
